module.exports = __webpack_public_path__ + "img/search-icon.dd90c98b.svg";